import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MediaObserver } from '@angular/flex-layout';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { take } from 'rxjs';
import { MerchantService } from '../crud-service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { AbstractCrudIndex } from 'src/app/shared/components/crud/abstract-crud-index';
import { ISlipResponse } from 'src/app/domain/registration/interfaces/slip.interface';
import { TABLE_CONFIG_COLUMNS, MerchantFilter } from '../crud-config';
import { TypeIndexEnum } from 'src/app/domain/registration/enums/type-index.enum';

const SELECT_COLUMNS = ['externalId', 'merchantName', 'documentNumber'];

@Component({
  selector: 'app-merchant-index-select',
  templateUrl: './crud-index-select.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [MerchantService],
})
export class MerchantIndexSelectComponent extends AbstractCrudIndex<ISlipResponse> {
  override title = 'SELECIONE UM COMERCIANTE';
  override configColumns = TABLE_CONFIG_COLUMNS;
  override COLUMNS_TO_SHOW_WEB = SELECT_COLUMNS;
  override COLUMNS_TO_SHOW_MOBILE = SELECT_COLUMNS;
  override displayedColumns = SELECT_COLUMNS;
  override filterFields = [];

  constructor(
    override dialog: MatDialog,
    override service: MerchantService,
    override toastService: ToastService,
    override mediaObserver: MediaObserver,
    override router: Router,
    public dialogRefSelect: MatDialogRef<MerchantIndexSelectComponent>,
    @Inject(MAT_DIALOG_DATA)
    data: {
      type: TypeIndexEnum;
      select: boolean;
      params?: any;
    }
  ) {
    super(dialog, service, toastService, mediaObserver, router);
    this.dataSelect = data;
    if (data?.params) {
      this.params = { ...this.params, ...data.params };
    }
    this.loadList();
  }

  override loadList(): void {
    const filters: MerchantFilter = {
    };

    this.service.getAllMerchants(filters, false).pipe(take(1)).subscribe({
      next: (result: any) => {
        if (result && Array.isArray(result) && result.length >= 2) {
          this.dataSource = new MatTableDataSource<any>(result[0] || []);
          this.length = result[1] || 0;
        } else {
          this.dataSource = new MatTableDataSource<any>([]);
          this.length = 0;
        }
      },
      error: (error) => {
        console.error('ERROR', error);
        this.toastService.showError('Erro ao buscar comerciantes. Tente novamente.');
        this.dataSource = new MatTableDataSource<any>([]);
        this.length = 0;
      }
    });
  }

  override submitAdvancedFilter(filterForm: any): void {
    const filters: MerchantFilter = {
      ...filterForm?.value,
      page: this.params.page,
      limit: this.params.limit,
    };

    this.service.getAllMerchants(filters, false).pipe(take(1)).subscribe({
      next: (result: any) => {
        if (result && Array.isArray(result) && result.length >= 2) {
          this.dataSource = new MatTableDataSource<any>(result[0] || []);
          this.length = result[1] || 0;
        } else {
          this.dataSource = new MatTableDataSource<any>([]);
          this.length = 0;
        }
      },
      error: (error) => {
        console.error('ERROR', error);
        this.toastService.showError('Erro ao buscar comerciantes. Tente novamente.');
        this.dataSource = new MatTableDataSource<any>([]);
        this.length = 0;
      }
    });
  }

  public onCancel(): void {
    this.dialogRefSelect.close();
  }

  public onSelect(data: any): void {
    this.dialogRefSelect.close(data?.row);
  }
}
